import React,{useState,useEffect} from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import TableDataLayer from "../components/TableDataLayer";
import SignUpUserTable from "../components/SignUpUserTable";
import { useParams } from "react-router-dom";
import { API_URL } from "..";

const SignUpUserPage = () => {
  // console.log(props)
  const { status } = useParams();
  const [jobsData , setJobData] = useState([])
  const fetchJobs = async ()=>{
    if(status === 'active'){

      let headersList = {
          "Accept": "*/*",
          "Content-Type": "application/json"
         }
         let response = await fetch(API_URL+ "/api/affiliates/fetch-affiliates/active", { 
           method: "GET",
           headers: headersList
         });
         let data = await response.json();
         setJobData(data)
    }
    
  else{
        let headersList = {
          "Accept": "*/*",
          "Content-Type": "application/json"
        }
        let response = await fetch(API_URL+"/api/affiliates/fetch-affiliates", { 
          method: "GET",
          headers: headersList
        });
        let data = await response.json();
        setJobData(data)
      }
        }

useEffect(()=>{
  fetchJobs()
},[1])
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title={status === 'active' ?  "Active Sign Up Affiliates":"Sign Up Affiliates"} />

        {/* TableDataLayer */}
        {
          jobsData.length == 0 ? null : 

        <SignUpUserTable status={status} jobsData={jobsData}/>
        }

      </MasterLayout>

    </>
  );
};

export default SignUpUserPage; 
